export default __webpack_public_path__ + "static/media/resultadofinal09.c0a8173c.pdf";